import classNames from "classnames";
import { useEffect, useState } from "react";
import styles from "./send-lead-loader.module.scss";

export function SendLeadLoader() {
  const [success, setSuccess] = useState(false);
  const [active, setActive] = useState(false);
  const [over, setOver] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setActive(true);
    }, 200);
  }, [setActive]);

  useEffect(() => {
    if (active) {
      setTimeout(() => {
        setSuccess(true);
        setTimeout(() => {
          setOver(true)
        }, 400);
      }, 900);
    }
  }, [setSuccess, active]);


  return (
    <div className={classNames(styles.underlay, { [styles.success]: success, [styles.active]: active, [styles.fadeOut]: over })}>
      <div className={classNames(styles.check, { [styles.active]: success })}></div>
      {active && <div className={styles.container}>
        <div className={styles.dot} style={{animationDelay: "100ms"}}></div>
        <div className={styles.dot} style={{animationDelay: "250ms"}}></div>
        <div className={styles.dot} style={{animationDelay: "400ms"}}></div>
      </div>}
    </div>
  )
}